/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Cities model module.
 * @module model/Cities
 * @version 1.0.0
 */
class Cities {
    /**
     * Constructs a new <code>Cities</code>.
     * @alias module:model/Cities
     */
    constructor() { 
        
        Cities.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Cities</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Cities} obj Optional instance to populate.
     * @return {module:model/Cities} The populated <code>Cities</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Cities();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * ID de la ciudad
 * @member {Number} id
 */
Cities.prototype['id'] = undefined;

/**
 * Nombre de la ciudad
 * @member {String} name
 */
Cities.prototype['name'] = undefined;






export default Cities;

